var startscroll;
var uagent = navigator.userAgent.toLowerCase();
var scrolli = 0;

$(function(){
	if (DetectMobileSafari()){
		$(".callWaitPhone").css("font-size", "8pt");
		$(".hdrGroups ul li a span").css("font-size", "8pt");
		$(".hdrWelcomeReg span").css("font-size", "8pt");
		$(".searchTextbox").css("width", "170px").css("border", "solid 1px #00468d");
	}
	$("a.copilotToggle").click(function(e) {
		e.preventDefault();
		$("#glance_cobrowse_btn").toggle();
	});
});

function DetectIphone()
{
   if (uagent.search("iphone") > -1)
      return true;
   else
      return false;
}

function DetectDroid()
{
 if (uagent.search("droid") > -1)
      return true;
   else
      return false;
}

function DetectIpod()
{
   if (uagent.search("ipod") > -1)
      return true;
   else
      return false;
}

function DetectIpad()
{
   if (uagent.search("ipad") > -1)
      return true;
   else
      return false;
}

function DetectMobileSafari()
{
    if (DetectIphone())
       return true;
    else if (DetectIpod())
       return true;
    else if (DetectIpad())
       return true;
    else
       return false;
}

function getInternetExplorerVersion()
{
  var rv = -1; // Return value assumes failure.
  if (navigator.appName == 'Microsoft Internet Explorer')
  {
    var ua = navigator.userAgent;
    var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
    if (re.exec(ua) != null)
      rv = parseFloat( RegExp.$1 );
  }
  return rv;
}